import { render, staticRenderFns } from "./CustomTree.vue?vue&type=template&id=12a8ae52&"
import script from "./CustomTree.vue?vue&type=script&lang=js&"
export * from "./CustomTree.vue?vue&type=script&lang=js&"
import style0 from "./CustomTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
import { VTreeview } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VTooltip,VTreeview})
